import React from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form } from "antd";
import { PurchaseTemplateForm } from "./components/PurchaseTemplateForm";
import { CREATE_REQUEST_TEMPLATE_MUTATION } from "./queries";

interface IPurchaseTemplate {
  id: string;
  name: string;
  templateKind?: 'REQUEST' | 'ORDER' | 'RECEIPT' | 'INSPECTION' | 'INVOICE' | 'PLAN' | 'PLAN_REPORT';
  teamId?: string;
  fiscalYear?: number;
  isActive: boolean;
  steps: { order: number; roleSlug: string; stepName?: string }[];
}

export const CreatePurchaseTemplate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<IPurchaseTemplate>({
    
    resource: "purchaseTemplates",
    meta: {
      gqlMutation: CREATE_REQUEST_TEMPLATE_MUTATION,
    },
  });

  ///const [form] = Form.useForm();

  return (
    <Create saveButtonProps={saveButtonProps} title="Create Purchase Template">
      <Form layout="vertical"  {...formProps}>
        <PurchaseTemplateForm />
      </Form>
    </Create>
  );
};